import { createComponent } from "../utils";
import verb from "verb-nurbs-web";

export default createComponent({
  name: "Divide Curve",
  group: "Curve",
  icon: () => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 388 388"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M376.98 0.27002H312.402C306.457 0.27002 301.636 5.08641 301.636 11.032V71.153L223.675 149.114V149.118C209.777 139.911 192.394 137.673 176.616 143.055C160.839 148.434 148.444 160.825 143.065 176.602C137.686 192.383 139.924 209.762 149.128 223.661L71.1506 301.638H11.0296C5.08427 301.638 0.267578 306.459 0.267578 312.404V376.982C0.267578 379.838 1.40038 382.572 3.41988 384.592C5.43548 386.611 8.17378 387.744 11.0293 387.744H75.6073C78.4628 387.744 81.2011 386.611 83.2206 384.592C85.2362 382.572 86.3729 379.838 86.3729 376.982V316.857L164.334 238.896C178.232 248.1 195.615 250.337 211.393 244.959C227.171 239.58 239.561 227.186 244.944 211.408C250.323 195.631 248.084 178.252 238.881 164.349L316.854 86.3759H376.979C379.835 86.3759 382.569 85.2392 384.589 83.2236C386.608 81.2041 387.741 78.4658 387.741 75.6103V11.0323C387.741 8.17682 386.608 5.43853 384.589 3.42293C382.569 1.40343 379.835 0.270615 376.979 0.270615L376.98 0.27002ZM64.8501 366.22H21.7951V323.169H64.8501V366.22ZM194.01 226.3C185.436 226.304 177.213 222.906 171.147 216.847C165.081 210.784 161.67 202.566 161.67 193.992C161.667 185.418 165.073 177.195 171.135 171.133C177.198 165.071 185.42 161.664 193.994 161.668C202.568 161.668 210.787 165.078 216.849 171.145C222.908 177.211 226.306 185.434 226.302 194.008C226.267 202.562 222.857 210.758 216.806 216.805C210.759 222.856 202.564 226.266 194.009 226.301L194.01 226.3ZM366.22 64.85H323.169V21.795H366.224L366.22 64.85Z"
        fill="currentColor"
      />
    </svg>
  ),
  description: "Divide a curve",
  controls: [],
  inputs: [
    {
      id: "curve",
      name: "Curve",
      type: "Curve",
    },
    {
      id: "division",
      name: "Division",
      type: "Number",
    },
  ],
  outputs: [
    {
      id: "points",
      name: "Points",
      type: "Point",
      compute: ({ curve, division = 10 }) => {
        if (curve) {
          const points = [];
          for (let i = 0; i <= division; i++) {
            curve.domain = [0, 1];
            const point = curve.pointAt(i / division);

            points.push(point);
          }

          return points;
        }
      },
    },
  ],
});
